import $ from "jquery";
export const fadeIn = {
    init: () => {
        fadeIn.enableGlobal();
        $("[data-fadein]").each(function () {
            const $thisElement = $(this);
            const fadeInDelay = parseInt($thisElement.data("fadein"));
            const currentOpacity = parseFloat($(this).css("opacity"));
            $thisElement.css({ opacity: 0, visibility: "visible", display: "block" });
            setTimeout(() => {
                $thisElement.animate({ opacity: currentOpacity, display: "block" });
            }, fadeInDelay);
        });
    },
    enableGlobal: () => {
        if (!window["fadeIn"]) {
            window["fadeIn"] = fadeIn;
        }
    },
};
